export default __webpack_public_path__ + "static/media/wPants_1_p2.ac91ce99.jpeg";